export default function () {
    const entityVideo = useEntityVideo();

    async function get(filter) {
        let videos = null,
            error = null,
            hasMore = false;
        try {
            const {data} = await useApi('videos').get('videos', filter);
            videos = data.videos.map((video) => {
                return entityVideo.build(video);
            });
            hasMore = videos.length === filter?.paginate?.limit;
        } catch (e) {
            error = useApiError(e);
        }
        return {videos, error, hasMore};
    }

    return {get};
}
